var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z",
    fill: "#057DCD",
    fillOpacity: 0.094
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.8334V27.5",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C12.279 25 12.067 24.9122 11.9107 24.7559C11.7545 24.5996 11.6667 24.3877 11.6667 24.1667V13.3333C11.6667 13.1123 11.7545 12.9004 11.9107 12.7441C12.067 12.5878 12.279 12.5 12.5 12.5H16.6667C17.5507 12.5 18.3986 12.8512 19.0237 13.4763C19.6488 14.1014 20 14.9493 20 15.8333C20 14.9493 20.3512 14.1014 20.9763 13.4763C21.6014 12.8512 22.4493 12.5 23.3333 12.5H27.5C27.721 12.5 27.933 12.5878 28.0893 12.7441C28.2455 12.9004 28.3333 13.1123 28.3333 13.3333V24.1667C28.3333 24.3877 28.2455 24.5996 28.0893 24.7559C27.933 24.9122 27.721 25 27.5 25H22.5C21.837 25 21.2011 25.2634 20.7322 25.7322C20.2634 26.2011 20 26.837 20 27.5C20 26.837 19.7366 26.2011 19.2678 25.7322C18.7989 25.2634 18.163 25 17.5 25H12.5Z",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebook);
export default __webpack_public_path__ + "static/media/webook.7e6d4f83fa6f8ced558ffcf5f27e8042.svg";
export { ForwardRef as ReactComponent };